<script>
    export default {
        name: 'NormalInput',
        props: {
            // 输入框类型
            type: {
                type: String,
                default: 'text',
                required: false
            },
            // 输入框限制输入正则
            pattern: {
                type: String,
                default: '',
                required: false
            },
            // 输入框提示性文字
            placeholder: {
                type: String,
                default: '',
                required: false
            },
            // 输入框值
            value: {
                default: '',
                required: false
            },
            // 是否有边框
            border: {
                type: Boolean,
                default: false,
                required: false
            },
            // 是否禁用
            disabled: {
                type: Boolean,
                default: false,
                required: false
            },
            // 是否有错误
            error: {
                type: Boolean,
                default: false,
                required: false
            },
            // 是否只读
            readonly: {
                type: Boolean,
                default: false,
                required: false
            },
            // 组件名称，用于form表单提交使用
            name: {
                type: String,
                default: '',
                required: false
            }
        },
        computed: {
            compClass () {
                return {
                    'normal-input-border': this.border,
                    'normal-input-error': this.error || !this.isPassValidator,
                    'normal-input__disabled': this.disabled,
                    [`normal-input-${this.type}`]: true
                };
            },
            compValue: {
                get () {
                    return this.selfValue;
                },
                set (val) {
                    this.selfValue = val;
                    this.$emit('input', val);
                }
            }
        },
        data () {
            return {
                selfValue: this.value,
                isPassValidator: true
            };
        },
        model: {
            prop: 'value',
            event: 'input'
        },
        watch: {
            value (v) {
                this.compValue = v;
            }
        },
        methods: {
            handleFocus ($e) {
                this.$emit('focus', $e);
            },
            handleBlur ($e) {
                this.$emit('blur', $e);
                this.handleValidator();
            },
            handleValidator () {
                if (!this.validator) {
                    return;
                }
                let funcArray = [];
                let result = true;
                if (this.validator instanceof Array) {
                    funcArray = this.validator;
                } else if (typeof this.validator === 'object') {
                    funcArray = Object.values(this.validator);
                } else if (typeof this.validator === 'function') {
                    funcArray = [this.validator];
                } else {
                    this.$emit('validator', [true]);
                }
                funcArray = funcArray.map(fuc => fuc(this.value)).filter(v => !v);
                result = !funcArray.length;
                this.isPassValidator = result;
                this.$emit('validator', funcArray);
            },
        }
    };
</script>

<template>
    <div>
        <template v-if="type !== 'textarea'">
            <input class="normal-input"
                   :required="type ==='date' ? true : false"
                   v-model="compValue"
                   :name="name"
                   :class="compClass"
                   :type="type"
                   :readonly="readonly"
                   :disabled="disabled"
                   :pattern="pattern"
                   @blur="handleBlur"
                   @focus="handleFocus"
                   :placeholder="placeholder">
        </template>
        <template v-else>
            <textarea class="normal-textarea"
                      v-model="compValue"
                      :name="name"
                      :class="compClass"
                      :type="type"
                      :readonly="readonly"
                      :disabled="disabled"
                      :pattern="pattern"
                      :placeholder="placeholder"
                      @blur="handleBlur"
                      @focus="handleFocus"></textarea>
        </template>
    </div>
</template>

<style scoped lang="less">
    @import "../../assets/less/widgets-var";

    input[type="date"] {
        &::before {
            color: #757575;
            content: attr(placeholder);
            width: 100%;
        }

        &:focus::before, &:valid::before {
            display: none
        }
    }


    .normal-input, .normal-textarea {
        box-sizing: border-box;
        width: 100%;
        border: 0;
        outline: 0;
        -webkit-appearance: none;
        background-color: transparent;
        font-size: inherit;
        color: inherit;
        .px2rem(height, 90);
        .px2rem(line-height, 90);
        .px2rem(padding-left, 28);
        .px2rem(padding-right, 28);

        &.normal-input__disabled {
            background: @otherDisabledBgClr;
            /*&:before{*/
            /**/
            /*}*/
        }

        &.normal-input-border {
            border: 1px solid @otherGreyBgClr;
            border-radius: 5px;
        }

        &.normal-input-error {
            border-color: @dangerBg;
            color: @dangerBg;
        }
    }

    .normal-textarea {
        .px2rem(padding, 28);
        resize: none;
        .px2rem(height, 270);
        line-height: inherit;
    }
</style>
